import script from "./BulkEditRequestModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkEditRequestModal.vue?vue&type=script&setup=true&lang=ts"

import "./BulkEditRequestModal.vue?vue&type=style&index=0&id=ae9ad17a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae9ad17a"]])

export default __exports__